import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface Timer extends SVGProps<SVGSVGElement> {
  label?: string
}

const Timer: React.FC<Timer> = ({ label = 'alert', ...restProps }) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none">
        <g clipPath="url(#clip0_6184_1129)">
          <path
            d="M1.99984 8C1.99984 4.74095 4.59825 2.08878 7.83641 2.00219C7.89071 2.00074 7.94519 2.00001 7.99984 2.00001C8.4014 2.00001 8.79311 2.03936 9.17154 2.11422C9.53273 2.18568 9.88345 1.9508 9.95491 1.58961C10.0264 1.22842 9.79148 0.877694 9.43029 0.80624C8.96711 0.714609 8.48874 0.666672 7.99984 0.666672C3.94975 0.666672 0.666504 3.94992 0.666504 8C0.666504 12.0501 3.94975 15.3333 7.99984 15.3333C9.65028 15.3333 11.1751 14.7873 12.4009 13.8663L12.4047 13.8635C13.0644 13.3672 13.6375 12.7622 14.0976 12.075C14.3024 11.769 14.2204 11.3549 13.9145 11.1501C13.6085 10.9453 13.1945 11.0273 12.9896 11.3332C12.5514 11.9878 11.9877 12.5515 11.3331 12.9898L11.3293 12.9923C10.3768 13.629 9.23247 14 7.99984 14C4.68613 14 1.99984 11.3137 1.99984 8Z"
            fill="#1A0244"
          />
          <path
            d="M8.6665 4C8.6665 3.63182 8.36803 3.33334 7.99984 3.33334C7.63165 3.33334 7.33317 3.63182 7.33317 4V8C7.33317 8.25252 7.47584 8.48336 7.70169 8.59629L10.3684 9.92962C10.6977 10.0943 11.0981 9.9608 11.2628 9.63148C11.4274 9.30216 11.294 8.90171 10.9646 8.73705L8.6665 7.58798V4Z"
            fill="#1A0244"
          />
          <path
            d="M12.0748 1.90223C11.7689 1.6974 11.3548 1.77938 11.15 2.08533C10.9451 2.39129 11.0271 2.80536 11.3331 3.01019C11.9877 3.44843 12.5514 4.01216 12.9896 4.66676C13.1945 4.97271 13.6085 5.05469 13.9145 4.84985C14.2204 4.64502 14.3024 4.23095 14.0976 3.925C13.5624 3.12557 12.8742 2.43743 12.0748 1.90223Z"
            fill="#1A0244"
          />
          <path
            d="M15.1936 6.56952C15.1221 6.20833 14.7714 5.97345 14.4102 6.04491C14.049 6.11636 13.8142 6.46709 13.8856 6.82828C13.9605 7.2067 13.9998 7.59841 13.9998 7.99998C13.9998 8.40155 13.9605 8.79326 13.8856 9.17168C13.8142 9.53287 14.049 9.8836 14.4102 9.95505C14.7714 10.0265 15.1221 9.79163 15.1936 9.43044C15.2852 8.96726 15.3332 8.48889 15.3332 7.99998C15.3332 7.51107 15.2852 7.0327 15.1936 6.56952Z"
            fill="#1A0244"
          />
        </g>
        <defs>
          <clipPath id="clip0_6184_1129">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </AccessibleIcon>
  )
}

export default Timer
